import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import { ProductPrices } from 'PMT/entities/menu';

// -- views
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';
import SvgIcon from 'PMT/components/SvgIcon';

export default class RowPricesView extends Component {

  static propTypes = {
    prices: PropTypes.objectOf(ProductPrices),
    currencyCode: PropTypes.string,
  };

  render() {
    return (
      <div className="row_prices_view text-left">
        <div>
          <SvgIcon
            icon={SvgIcon.ORDER_ON_SITE}
            style={styles.svg}
          />
          <EnabledDisabledIcon
            className="vcenter"
            value={this.props.prices.onSite.available}
            style={styles.enabledDisabledIcon}
          />
          <span
            style={styles.price}
            className="vcenter"
          >
            {CurrencyUtils.formatPriceWithCurrency(
                this.props.prices.onSite.priceIncludingTax,
                this.props.currencyCode)}
          </span>
        </div>

        <div>
          <SvgIcon
            icon={SvgIcon.ORDER_TAKE_AWAY}
            style={styles.svg}
          />
          <EnabledDisabledIcon
            className="vcenter"
            value={this.props.prices.takeAway.available}
            style={styles.enabledDisabledIcon}
          />
          <span
            style={styles.price}
            className="vcenter"
          >
            {CurrencyUtils.formatPriceWithCurrency(
                this.props.prices.takeAway.priceIncludingTax,
                this.props.currencyCode)}
          </span>
        </div>

        <div>
          <SvgIcon
            icon={SvgIcon.ORDER_DELIVERY}
            style={styles.svg}
          />
          <EnabledDisabledIcon
            className="vcenter"
            value={this.props.prices.delivery.available}
            style={styles.enabledDisabledIcon}
          />
          <span
            style={styles.price}
            className="vcenter"
          >
            {CurrencyUtils.formatPriceWithCurrency(
                this.props.prices.delivery.priceIncludingTax,
                this.props.currencyCode)}
          </span>
        </div>
      </div>
    );
  }

}

const styles = {
  svg: {
    display: 'inline-block',
    width: '20px'
  },
  enabledDisabledIcon: {
    marginLeft: '10px'
  },
  price: {
    marginLeft: '6px',
    marginTop: '-8px'
  }
}



// WEBPACK FOOTER //
// ./scripts/components/order/RowPricesView.js